// extracted by mini-css-extract-plugin
export default {"richtext":"zP5kyme","richtext-in-accordion":"Xc3UNuQ"};